import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsconfig from './aws-exports'
Amplify.configure(awsconfig)
import axios from 'axios'
Vue.prototype.$http = axios
import StarRating from 'vue-star-rating'
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import vueDebounce from 'vue-debounce'
import VueTour from 'vue-tour'

Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' });
Vue.config.productionTip = false

Vue.use(vueDebounce)

Vue.use(VueTour)

Vue.use(AmplifyPlugin, AmplifyModules)
Vue.component('star-rating', StarRating);
import VueGtag from "vue-gtag";

require('vue-tour/dist/vue-tour.css')

Vue.use(VueGtag, {
  config: { id: "UA-155093893-2" },
  params: {
    send_page_view: false,
    appName: 'AppAlgoReady',
    pageTrackerScreenviewEnabled: true
  }
}, router);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
